import { render, staticRenderFns } from "./UsuarioLogado.vue?vue&type=template&id=52d0b645&scoped=true"
import script from "./UsuarioLogado.vue?vue&type=script&lang=js"
export * from "./UsuarioLogado.vue?vue&type=script&lang=js"
import style0 from "./UsuarioLogado.vue?vue&type=style&index=0&id=52d0b645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0b645",
  null
  
)

export default component.exports